import { render, staticRenderFns } from "./SiteNotificationListItem.vue?vue&type=template&id=fbd72eb0&scoped=true&"
import script from "./SiteNotificationListItem.vue?vue&type=script&lang=js&"
export * from "./SiteNotificationListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd72eb0",
  null
  
)

export default component.exports